import React from "react";
import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, defaultBooleanField, mapAsOfSubtextDate } from "helpers/row-logic-helper";

import { shouldShowField } from "../loanDetailEditUtil";

import {
  shouldShowMonthlySub
  , shouldShowQuarterlySub
  , shouldShowSemiAnnuallySub
  , shouldShowAnnuallySub
  , shouldShowBorrowerDeliveryPeriodMonthly
  , shouldShowBorrowerDeliveryPeriodQuarterly
  , shouldShowBorrowerDeliveryPeriodSemiAnnually
  , shouldShowBorrowerDeliveryPeriodAnnually
  , shouldShowListOfDocsMonthly
  , shouldShowListOfDocsQuarterly
  , shouldShowListOfDocsSemiAnnually
  , shouldShowListOfDocsAnnually
  , shouldShowBorrowerDocsMonthly
  , shouldShowBorrowerDocsQuarterly
  , shouldShowBorrowerDocsSemiAnnually
  , shouldShowBorrowerDocsAnnually
  , shouldShowSignor
} from "./section-loan-borrower-docs-row-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  monthlySubSection: {
    isVisible: loan => shouldShowMonthlySub(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "Monthly",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        className: "subsection",
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.covenants.borrowerDocsMonthly"
      }
    ]
  },

  calculationPeriodsMonthly: {
    isVisible: data => shouldShowBorrowerDeliveryPeriodMonthly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Delivery Period (days)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.borrowerDeliveryPeriodMonthly"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  listOfDocsMonthly: {
    isVisible: data => shouldShowListOfDocsMonthly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List Of Docs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => {
          const listOfDocs = defaultField(data, "covenants.borrowerListOfDocsMonthly");
          const list = listOfDocs.sort((a, b) => (`${a.name}`).localeCompare(b.name)).map(x => (<p>{x.name}</p>));
          if (list.length > 0) {
            return list;
          }

          return [];
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  borrowerDocsMonthlyReportingStart: {
    isVisible: data => shouldShowBorrowerDocsMonthly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => mapAsOfSubtextDate(data, "covenants.borrowerDocsMonthlyReportingStart"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  quarterlySubSection: {
    isVisible: loan => shouldShowQuarterlySub(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "Quarterly",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        className: "subsection",
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.covenants.borrowerDocsQuarterly"
      }
    ]
  },

  borrowerDeliveryPeriodQuarterly: {
    isVisible: data => shouldShowBorrowerDeliveryPeriodQuarterly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Delivery Period (days)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.borrowerDeliveryPeriodQuarterly"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  listOfDocsQuarterly: {
    isVisible: data => shouldShowListOfDocsQuarterly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List Of Docs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => {
          const listOfDocs = defaultField(data, "covenants.borrowerListOfDocsQuarterly");
          const list = listOfDocs.sort((a, b) => (`${a.name}`).localeCompare(b.name)).map(x => (<p>{x.name}</p>));
          if (list.length > 0) {
            return list;
          }

          return [];
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  borrowerDocsQuarterly: {
    isVisible: data => shouldShowBorrowerDocsQuarterly(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => mapAsOfSubtextDate(data, "covenants.borrowerDocsQuarterlyReportingStart"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  semiAnnuallySubSection: {
    isVisible: loan => shouldShowSemiAnnuallySub(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "Semi-Annually",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        className: "subsection",
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.covenants.borrowerDocsSemiAnnually"
      }
    ]
  },

  borrowerDeliveryPeriodSemiAnnually: {
    isVisible: data => shouldShowBorrowerDeliveryPeriodSemiAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Delivery Period (days)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.borrowerDeliveryPeriodSemiAnnually"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  listOfDocsSemiAnnually: {
    isVisible: data => shouldShowListOfDocsSemiAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List Of Docs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => {
          const listOfDocs = defaultField(data, "covenants.borrowerListOfDocsSemiAnnually");
          const list = listOfDocs.sort((a, b) => (`${a.name}`).localeCompare(b.name)).map(x => (<p>{x.name}</p>));
          if (list.length > 0) {
            return list;
          }

          return [];
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  borrowerDocsSemiAnnually: {
    isVisible: data => shouldShowBorrowerDocsSemiAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => mapAsOfSubtextDate(data, "covenants.borrowerDocsSemiAnnuallyReportingStart"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  annuallySubSection: {
    isVisible: loan => shouldShowAnnuallySub(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "Annually",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        className: "subsection",
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.covenants.borrowerDocsAnnually"
      }
    ]
  },

  borrowerDeliveryPeriodAnnually: {
    isVisible: data => shouldShowBorrowerDeliveryPeriodAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Delivery Period (days)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.borrowerDeliveryPeriodAnnually"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  listOfDocsAnnually: {
    isVisible: data => shouldShowListOfDocsAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List Of Docs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => {
          const listOfDocs = defaultField(data, "covenants.borrowerListOfDocsAnnually");
          const list = listOfDocs.sort((a, b) => (`${a.name}`).localeCompare(b.name)).map(x => (<p>{x.name}</p>));
          if (list.length > 0) {
            return list;
          }

          return [];
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  borrowerDocsAnnually: {
    isVisible: data => shouldShowBorrowerDocsAnnually(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => mapAsOfSubtextDate(data, "covenants.borrowerDocsAnnuallyReportingStart"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  generalSubSection: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "General",
        Cell: tableSideColumnMapper,
        colSpan: 2
      }
    ]
  },

  borrowerOfficerCertificate: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Officer Certificate",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultBooleanField(data, "covenants.borrowerOfficerCertificate", "Required", "Not Required"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  signor: {
    isVisible: data => shouldShowSignor(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Signor",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.borrowerSignor.fullName"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
